// extracted by mini-css-extract-plugin
module.exports = {"indicatorWrap":"DropdownIndicatorPart_indicatorWrap__3kM9g","icon":"DropdownIndicatorPart_icon__28gqd"};